import {AdType, SubCategory} from "../interfaces/ad";

export const PRICE_PER_PUBLICATION: number = 15.00;
export const CIPHER_FEE: number = 11.90;

export function getCategoryList(): string[] {
  return [
    'Dies & Das',
    'Immobilien',
    'Job',
    'Mobiles',
  ];
}

export function getSubCategoryList():SubCategory[] {
  return [
    {
      masterCategory: 'Dies & Das',
      name: 'Antiquitäten',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Baby & Kind',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Bekanntschaften',
      payable: true,
      adTypes: [AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Mode & Beauty',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Dienstleistungen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Elektrogeräte',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Entlaufen/Entflogen',
      payable: true,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Gebrauchtmöbel',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Gefunden',
      payable: false,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Haus & Garten',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Haushaltsauflösung',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Landwirtschaftliche Erzeugnisse',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Musik, Filme, Bücher',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Sportzubehör',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Tiermarkt',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Tierschutz',
      payable: false,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Tierzubehör',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Unterricht',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Verloren',
      payable: true,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Verschenken',
      payable: false,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Verschiedenes',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Dies & Das',
      name: 'Zugelaufen/Zugeflogen',
      payable: false,
      adTypes: [AdType.GOOD_DEED]
    },
    {
      masterCategory: 'Immobilien',
      name: 'Private Grundstücke',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Immobilien',
      name: 'Immobilien',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Immobilien',
      name: 'Vermietungen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Job',
      name: 'Stellen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    }, {
      masterCategory: 'Mobiles',
      name: 'Autoanhänger',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    }, {
      masterCategory: 'Mobiles',
      name: 'Autozubehör',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Boote',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Fahrräder',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Geländewagen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Zweiräder',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Motorradzubehör',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Nutzfahrzeuge & Landmaschinen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Oldtimer',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'PKW',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    },
    {
      masterCategory: 'Mobiles',
      name: 'Wohnmobile & Wohnwägen',
      payable: true,
      adTypes: [AdType.OFFER, AdType.WANTED]
    }
  ];
}

export function getLocalityList(): string[]{
  return [
    "Achern",
    "andere Orte",
    "Appenweier",
    "Bad Peterstal-Griesbach",
    "Bad Rippoldsau",
    "Berghaupten",
    "Biberach",
    "Bühl",
    "Durbach",
    "Ettenheim",
    "Fischerbach",
    "Friesenheim",
    "Gengenbach",
    "Gutach",
    "Haslach",
    "Hausach",
    "Hofstetten",
    "Hohberg",
    "Hornberg",
    "Kappel-Grafenhausen",
    "Kappelrodeck",
    "Kehl",
    "Kippenheim",
    "Lahr",
    "Lauf",
    "Lautenbach",
    "Mahlberg",
    "Meissenheim",
    "Mühlenbach",
    "Neuried",
    "Nordrach",
    "Oberharmersbach",
    "Oberkirch",
    "Oberwolfach",
    "Offenburg",
    "Ohlsbach",
    "Oppenau",
    "Ortenberg",
    "Ottenhöfen",
    "Renchen",
    "Rheinau",
    "Ringsheim",
    "Rust",
    "Sasbach",
    "Sasbachwalden",
    "Schenkenzell",
    "Schiltach",
    "Schuttertal",
    "Schutterwald",
    "Schwanau",
    "Seebach",
    "Seelbach",
    "Steinach",
    "Strasbourg",
    "Willstätt",
    "Wolfach",
    "Zell a.H."
  ];
}
